"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMode = void 0;
const react_1 = __importStar(require("react"));
const select_1 = require("../select");
const react_select_1 = require("react-select");
const items_1 = require("../items");
const Menu = (props) => {
    return (react_1.default.createElement(react_select_1.components.Menu, Object.assign({}, props),
        react_1.default.createElement(items_1.Items, { items: props.options, onItemClick: props.selectOption, checkSelection: (item) => { var _a; return item.id === ((_a = props.getValue()[0]) === null || _a === void 0 ? void 0 : _a.id); } })));
};
const customComponents = { Menu };
const customStyles = {
    dropdownIndicator: (provided, { isDisabled }) => {
        return Object.assign(Object.assign({}, provided), { display: isDisabled ? 'none' : provided.display });
    }
};
const MobileMode = ({ items, disabled, checkSelection, onItemClick }) => {
    const options = (0, react_1.useMemo)(() => items.map((item) => (Object.assign(Object.assign({}, item), { value: item.id, label: item.title }))), [items]);
    const currentValue = (0, react_1.useMemo)(() => {
        const flatOptions = options.reduce((acc, option) => {
            if (option.children) {
                return [
                    ...acc,
                    ...option.children.map((item) => (Object.assign(Object.assign({}, item), { value: item.id, label: item.title })))
                ];
            }
            else {
                acc.push(option);
                return acc;
            }
        }, []);
        return checkSelection && flatOptions.find(checkSelection);
    }, [options, checkSelection]);
    return (react_1.default.createElement(select_1.Select, { options: options, components: customComponents, styles: customStyles, onChange: onItemClick, value: currentValue, disabled: disabled, maxMenuHeight: "60vh", isSearchable: false }));
};
exports.MobileMode = MobileMode;
